import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500">Loading…</div>
    );
  }
  if (!user) return <Navigate to="/sign-in" replace state={{ from: location }} />;
  return <>{children}</>;
}
